(function(){
  // --- Config ---
  const RESTRICT_TO_IPAD = false; // set to false if you want kiosk UI on any device when kiosk flag is on

  // --- Helpers ---
  const params = new URLSearchParams(location.search);
  const isIPad = (() => {
    const ua = navigator.userAgent || "";
    return /\biPad\b/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  })();

  if (params.get('kiosk') === '1' || params.get('kiosk') === 'true') {
    try { localStorage.setItem('kiosk','1'); } catch {}
  }
  if (params.get('kiosk') === '0' || params.get('nokiosk') === '1') {
    try { localStorage.removeItem('kiosk'); } catch {}
  }

  const kioskOn = (localStorage.getItem('kiosk') === '1') && (!RESTRICT_TO_IPAD || isIPad);
  if (!kioskOn) return;

  // --- Styles (centered, red, white triangles; container doesn't block scroll) ---
  const css = document.createElement('style');
  css.textContent = `
    #kiosk-nav {
      position: fixed;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 16px;
      z-index: 2147483647;
      user-select: none;
      pointer-events: none; /* container ignores touches */
    }
    #kiosk-nav button {
      pointer-events: auto;           /* buttons receive touches */
      width: 70px;
      height: 70px;
      border-radius: 50%;
      border: none;
      background-color: rgb(193, 44, 42); /* your red */
      box-shadow: 0 2px 10px rgba(0,0,0,.2);
      cursor: pointer;
      touch-action: manipulation;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
    }
    /* White triangle icons */
    #kiosk-back::before,
    #kiosk-fwd::before {
      content: "";
      display: block;
      width: 0; height: 0;
      border-style: solid;
    }
    #kiosk-back::before {
      border-width: 15px 20px 15px 0;
      border-color: transparent white transparent transparent;
    }
    #kiosk-fwd::before {
      border-width: 15px 0 15px 20px;
      border-color: transparent transparent transparent white;
    }
    #kiosk-home::before {
      content: "";
      display: block;
      width: 24px;
      height: 24px;
      background-color: white;
      -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'%3E%3C/path%3E%3Cpolyline points='9 22 9 12 15 12 15 22'%3E%3C/polyline%3E%3C/svg%3E") no-repeat center;
      mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'%3E%3C/path%3E%3Cpolyline points='9 22 9 12 15 12 15 22'%3E%3C/polyline%3E%3C/svg%3E") no-repeat center;
    }
    #kiosk-nav button:disabled { opacity: .5; cursor: default; }
    /* Hide Account Button */
    .header__icon[href*="customer_authentication"],
    .header__icon[href*="/account"] {
      display: none !important;
    }
    @media print { #kiosk-nav { display: none; } }
  `;
  document.head.appendChild(css);

  // --- Tiny safe nav stacks (avoid iPad white spinner; support Forward) ---
  const HOME_URL = location.origin + '/';
  const BACK_KEY = 'kioskNavStack_v1';     // our "visited pages" stack
  const FWD_KEY  = 'kioskFwdStack_v1';     // our forward stack

  const load = (k, d='[]') => { try { return JSON.parse(localStorage.getItem(k) || d); } catch { return JSON.parse(d); } };
  const save = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} };
  const clear = (k)    => { try { localStorage.removeItem(k); } catch {} };
  const isInternal = (u) => { try { return new URL(u, location.href).origin === location.origin; } catch { return false; } };

  // Prime back stack with current URL
  (function prime(){
    const s = load(BACK_KEY);
    const cur = location.href;
    if (!s.length || s[s.length - 1] !== cur) {
      s.push(cur);
      if (s.length > 100) s.splice(0, s.length - 100);
      save(BACK_KEY, s);
    }
  })();

  // --- UI ---
  const nav = document.createElement('div');
  nav.id = 'kiosk-nav';
  nav.innerHTML =
    '<button id="kiosk-back" type="button" title="Back" aria-label="Back"></button>' +
    '<button id="kiosk-home" type="button" title="Home" aria-label="Home"></button>' +
    '<button id="kiosk-fwd"  type="button" title="Forward" aria-label="Forward"></button>';
  document.addEventListener('DOMContentLoaded', () => document.body.appendChild(nav));

  // --- Behavior ---
  function goBackSafe(){
    let back = load(BACK_KEY);
    let fwd  = load(FWD_KEY);

    // Align top to current if needed
    if (back.length && back[back.length - 1] !== location.href) back.push(location.href);

    // Pop current
    if (back.length) back.pop();

    // Find nearest valid internal entry
    while (back.length && !isInternal(back[back.length - 1])) back.pop();

    // Determine target
    const target = back.length ? back[back.length - 1] : HOME_URL;

    // Push current into forward stack (so forward works)
    fwd.push(location.href);
    save(FWD_KEY, fwd);

    // Save trimmed back stack
    save(BACK_KEY, back);

    // Navigate (no history.back() to avoid iPad white screen)
    location.assign(target);
  }

  function goForwardSafe(){
    let fwd = load(FWD_KEY);
    if (!fwd.length) return;

    const target = fwd.pop(); // last pushed is the immediate forward
    save(FWD_KEY, fwd);

    // Also record this move in back stack
    let back = load(BACK_KEY);
    if (!back.length || back[back.length - 1] !== location.href) {
      back.push(location.href);
      if (back.length > 100) back.splice(0, back.length - 100);
      save(BACK_KEY, back);
    }

    location.assign(target);
  }

  function goHome(){
    // Clear forward stack just like a new branch
    clear(FWD_KEY);
    // Navigate home with kiosk param
    location.assign('https://www.cloment.com/?kiosk=1');
  }

  document.addEventListener('DOMContentLoaded', () => {
    const backBtn = document.getElementById('kiosk-back');
    const homeBtn = document.getElementById('kiosk-home');
    const fwdBtn  = document.getElementById('kiosk-fwd');
    backBtn.addEventListener('click', goBackSafe);
    homeBtn.addEventListener('click', goHome);
    fwdBtn.addEventListener('click', goForwardSafe);
    // Always keep Back enabled; Forward enabled only if we have entries
    const update = () => {
      const fwd = load(FWD_KEY);
      fwdBtn.disabled = fwd.length === 0;
    };
    update();
    window.addEventListener('pageshow', update);
    document.addEventListener('visibilitychange', update);
  });

  // Keep the kiosk flag across internal links AND clear forward stack on new branches
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a) return;
    if (e.defaultPrevented || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    try {
      const u = new URL(a.getAttribute('href'), location.href);
      if (u.origin === location.origin) {
        // keep kiosk flag
        if (!u.searchParams.has('kiosk')) u.searchParams.set('kiosk','1');
        a.setAttribute('href', u.toString());

        // new navigation branch → clear forward stack (just like real browsers)
        clear(FWD_KEY);
      }
    } catch {}
  }, { capture: true });

})();
